// layout
import { ModuleLayout } from '@/components/reusable_components/next'

// views
import PchPurchaseOrderDetailView from '@/views/Purchase/PchPurchaseOrder/PchPurchaseOrderDetail'
import PchPurchaseOrderListView from '@/views/Purchase/PchPurchaseOrder/PchPurchaseOrderList'
import PurchaseOrderPendingListView from '@/views/Purchase/PchPurchaseOrder/PurchaseOrderPending'

// routes
export default {
  path: 'purchase_orders',
  component: ModuleLayout,
  children: [
    {
      path: '',
      name: 'purchase-order-list',
      component: PchPurchaseOrderListView,
    },
    {
      path: ':id',
      name: 'purchase-order-detail',
      component: PchPurchaseOrderDetailView,
      meta: {
        title: 'Detalle Orden de Compra'
      },
    },
  ],
  meta: {
    title: 'Ordenes de compra',
  }
}

//
export const PurchaseOrderPendingRoutes = {
  path: 'purchase_invoice_receive',
  component: ModuleLayout,
  children: [
    {
      path: '',
      name: 'purchase-order-pending-list',
      component: PurchaseOrderPendingListView,
    },
    {
      path: ':id',
      name: 'purchase-orders-detail',
      component: PchPurchaseOrderDetailView,
      meta: {
        title: 'Detalle Orden de Compra'
      },
    },
  ],
  meta: {
    title: 'Listado de facturas por recepcionar'
  },
}